<!-- ====================== -->
<!--      VISTA MÓVIL      -->
<!-- ====================== -->
<div class="flex justify-center p-4 md:hidden" *ngIf="showSearchEsim">
  <div class="bg-white rounded-2xl shadow-md overflow-hidden max-w-md w-full">
    
    <!-- Imagen superior completa -->
    <img src="./assets/icons/esim-header.png" class="w-full h-48 object-cover"  alt="eSIM" />

    <div class="p-6">
      <h2 class="text-xl font-bold text-black text-center">
        {{ 'ESIM.SEARCH_TITLE_1' | translate }}
      </h2>

      <p class="text-center text-black mt-2 mb-6">
        {{ 'ESIM.SEARCH_TITLE_2' | translate }}
      </p>

      <!-- Selector Tipo -->
      <div class="custom-select-box mb-4">
        <div class="custom-select-label">
              <img src="https://cdn.zendy.tel/images/ico-world-black.svg" width="20">
            </div>
        <mat-select [(ngModel)]="selectedType"
                    (selectionChange)="onTypeChange()"
                    placeholder="{{'ESIM.SELECT_TIPO'|translate}}">
          <mat-option *ngFor="let type of types" [value]="type">
            {{ "ESIM." + type | uppercase | translate }}
          </mat-option>
        </mat-select>
      </div>

        <!-- Selector País con buscador interno -->
        <div class="custom-select-box mb-4">
          <!-- Selector tipo -->
            <div class="custom-select-label">
              <img  src="https://cdn.zendy.tel/images/ico-esim-black.svg" width="20"/>
            </div>

            <mat-select
              #countrySelect
              panelClass="custom-select-panel"
              [(ngModel)]="selectedCountry"
              [disabled]="isDisabled"
              (selectionChange)="onTypeChange2()"
              placeholder="{{ 'ESIM.SELECT_COUNTRY' | translate }}"
            >
              <mat-option
                *ngFor="let country of filteredCountries"
                [value]="country.code"
              >
                <div class="flex items-center">
                  <img
                    [src]="country.image"
                    alt="{{ country.country }}"
                    class="country-flag mr-2 w-6 h-4"
                  />
                  <span>{{ country.country }}</span>
                </div>
              </mat-option>
            </mat-select>

        </div>

      <!-- Botón Buscar -->
      <button mat-raised-button
              class="!w-full !bg-red-600 !hover:bg-red-700 text-white font-bold py-3 !rounded-full"
              style="color: white;"
              [disabled]="isDisabled2"
              (click)="loadEsimPackages()">
        {{ 'ESIM.BTN_SEARCH_ESIM' | translate }}
      </button>

      <!-- Botón Mis eSIMs -->
      <button mat-stroked-button
              class="w-full mt-3 border-gray-400 text-black font-bold py-3 rounded-full !rounded-full "
              *ngIf="!isIframe"
              (click)="goToMyEsims()">
        {{ 'ESIM.BTN_MY_ESIM' | translate }}
      </button>

    </div>
  </div>
</div>



<!-- ====================== -->
<!--    VISTA ESCRITORIO    -->
<!-- ====================== -->
<div class="hidden md:grid grid-cols-2 gap-10 max-w-5xl mx-auto py-12" *ngIf="showSearchEsim">

  <!-- Imagen izquierda alineada EXACTAMENTE al contenido -->
  <div class="relative w-full h-full  flex">    
    <img src="./assets/icons/esim-header.png"
         alt="ESIM" class="rounded-3xl shadow-md object-cover object-left w-full"
         style="height: 100%; max-height: 540px;" />
  </div>

  <!-- Texto + Selectores + Botones -->
  <div class="flex flex-col justify-center" #desktopContent>

    <h1 class="text-4xl font-bold text-gray-900 leading-tight mb-4" style="color: black;">
      {{ 'ESIM.SEARCH_TITLE_1' | translate }}
    </h1>

    <p class="text-gray-700 mb-5">
      {{ 'ESIM.SEARCH_TITLE_2' | translate }}
    </p>

    <!-- Bullets traducidos -->
    <ul class="text-gray-700 mb-8 space-y-2">
      <li class="flex items-center gap-2">
        <span class="text-red-600 text-lg">✔</span>{{ 'ESIM.NO_ROAMING' | translate }}
      </li>
      <li class="flex items-center gap-2">
        <span class="text-red-600 text-lg">✔</span>{{ 'ESIM.GLOBAL_COVERAGE' | translate }}
      </li>
      <li class="flex items-center gap-2">
        <span class="text-red-600 text-lg">✔</span>{{ 'ESIM.LOW_PRICES' | translate }}
      </li>
    </ul>

    <!-- Selectores -->
    <div class="grid grid-cols-1 gap-4 mb-6">

          <!-- Selector tipo -->
          <div class="custom-select-box" >
            <div class="custom-select-label">
              <img src="https://cdn.zendy.tel/images/ico-world-black.svg" width="20">
            </div>
            <mat-select class=""
                        [(ngModel)]="selectedType"
                        (selectionChange)="onTypeChange()"
                        placeholder="{{'ESIM.SELECT_TIPO'|translate}}">
              <mat-option *ngFor="let type of types" [value]="type">
                {{ "ESIM." + type | uppercase | translate }}
              </mat-option>
            </mat-select>
          </div>

         <!-- Selector tipo -->
          <div class="custom-select-box">
            <div class="custom-select-label">
              <img  src="https://cdn.zendy.tel/images/ico-esim-black.svg" width="20"/>
            </div>

            <mat-select
              #countrySelect
              panelClass="custom-select-panel"
              [(ngModel)]="selectedCountry"
              [disabled]="isDisabled"
              (selectionChange)="onTypeChange2()"
              placeholder="{{ 'ESIM.SELECT_COUNTRY' | translate }}"
            >
              <mat-option
                *ngFor="let country of filteredCountries"
                [value]="country.code"
              >
                <div class="flex items-center">
                  <img
                    [src]="country.image"
                    alt="{{ country.country }}"
                    class="country-flag mr-2 w-6 h-4"
                  />
                  <span>{{ country.country }}</span>
                </div>
              </mat-option>
            </mat-select>
          </div>

          <!-- campo de búsqueda -->
          <ng-template #filterInput>
            <div class="search-overlay-input">
              <input
                placeholder="{{ 'ESIM.COUNTRY.PLACEHOLDER' | translate }}"
                (keyup)="onKey($event)"
                (click)="$event.stopPropagation()"
              />
            </div>
          </ng-template>
    </div>

    <!-- Botones -->
    <div class="flex gap-4">
      <button mat-raised-button
              class="!bg-red-600 !hover:bg-red-700 text-white px-6 py-3 rounded-lg font-bold"
              style="color: white;"
              [disabled]="isDisabled2"
              (click)="loadEsimPackages()">
        {{ 'ESIM.BTN_SEARCH_ESIM' | translate }}
      </button>

      <button mat-stroked-button
              class="!border-gray-400 !text-black px-6 py-3 rounded-lg font-bold my-esims-btn"
              *ngIf="!isIframe"
              (click)="goToMyEsims()">
        {{ 'ESIM.BTN_MY_ESIM' | translate }}
      </button>
    </div>

  </div>
</div>

<!-- Mostrar múltiples tarjetas si hay más de una -->
<div *ngIf="filteredPackages.length > 0" class="grid my-6 !gap-2">
  <h2 class="text-xl font-bold text-center">
    <mat-icon (click)="goToEsimSearcher()" class="float-left ms-4 cursor-pointer">arrow_back_ios</mat-icon>{{ countryName | titlecase }}
  </h2>
</div>

<div *ngIf="filteredPackages.length > 0" class="grid grid-cols-2 my-4 !gap-0">
  <div class="sims-tab m-0 pb-4 cursor-pointer" [ngClass]="sim_status_data ? 'active' : ''" (click)="toggleClassData()">{{ "ESIM.DATA" | translate }}</div>
  <div class="sims-tab m-0 pb-4 cursor-pointer" [hidden]="dataVoiceEsims" [ngClass]="sim_status_data_voice ? 'active' : ''" (click)="toggleClassDataVoice()">{{ "ESIM.DATA-VOICE-TEXT" | translate }}</div>
</div>

<div *ngIf="filteredPackages.length > 0" id="misEsim" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-4">

  <mat-card *ngFor="let package of filteredPackages" class="lg:max-w-[450px] esim-card {{ package.operador[0].plan_type }} {{ filteredPackages.length > 1 ? '' : 'esim-card-single' }}" [ngClass]="package.operador[0].plan_type == 'data' ? esim_data_visible : esim_data_voice_visible" appearance="outlined">
    <mat-card-header class="flex items-start">
      <div class="header-image-container !mr-4">
        <img mat-card-image [src]="package.operador[0].image" alt="{{ package.operador[0].operador }}"
             class="sim-card-image-small">
        <span class="country-label">{{ capitalizeCountryName(package.country) }}</span>
      </div>
      <div>
        <h2 class="text-black m-0 text-xl">{{ package.title }}</h2>
        <h2 class="m-0 text-xl">{{ package.price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</h2>
        <div class="flex" style="height:fit-content;">
          <div *ngFor="let item of package.operador[0].plan_type.split('-')">
            <img width="16" [src]="'./assets/icons/' + item + '_ico.svg'" title="{{ item }}" class="me-1" />
          </div>
        </div>
      </div>
    </mat-card-header>

    <hr>

    <mat-card-content>
      <div class="item-detail flex items-center mb-1">
        <mat-icon class="text-red-700">public</mat-icon>
        <label class="item-label font-bold mx-1">{{ 'ESIM.COVERAGE' | translate }}: </label>
        <span class="item-value">
          {{ package.country | titlecase }}
        </span>
      </div>
      <div class="item-detail flex items-center my-1">
        <mat-icon class="text-red-700">swap_horiz</mat-icon>
        <label class="item-label font-bold mx-1">{{ 'ESIM.DATA' | translate }}: </label>
        <span class="item-value">
          {{ package.data }}
        </span>
      </div>

      <div class="item-detail flex items-center my-1">
        <mat-icon class="text-red-700">sim_card</mat-icon>
        <label class="item-label font-bold mx-1">{{ 'ESIM.TYPE' | translate }}: </label>
        <span class="item-value">
          {{ "ESIM."+package.operador[0].plan_type | uppercase | translate }}. {{ package.operador[0].esimtype }}
        </span>
      </div>
      <div class="item-detail flex items-center mt-1">
        <mat-icon class="text-red-700">date_range</mat-icon>
        <label class="item-label font-bold mx-1">{{ 'ESIM.VALIDITY' | translate }}: </label>
        <span class="item-value">
          {{ package.day }} {{ package.day > 1 ? ('ESIM.DAYS' | translate) : ('ESIM.DAY' | translate) }}
        </span>
      </div>
      <div class="item-detail flex items-center mt-1">
        <mat-icon class="text-red-700">autorenew</mat-icon>
        <label class="item-label font-bold mx-1">{{ 'ESIM.DETAILS.RECHARGEABILITY' | translate }}: </label>
        <span class="item-value">
          {{ package.operador[0].rechargeability+'' | uppercase | translate }}
        </span>
      </div>

    </mat-card-content>

    <mat-card-actions>
      <div class="buybutton mt-4">
        <!--button mat-button (click)="openBuyNowDialog(package)">{{ 'ESIM.BUY_NOW' | translate }}</button -->
        <button mat-button class="view-btn" (click)="openPackagePurchaseDetails(package, package.id)">{{ 'ESIM.BUY_NOW' | translate }}</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>






<style>
.selector-box {
  @apply bg-gray-100 rounded-xl px-4 py-3;
}
.mat-select-placeholder {
  @apply text-gray-500;
}
.mat-select {
  width: 100% !important;
}

/* Alineación perfecta en escritorio */
@media (min-width: 768px) {
  .image-container,
  .desktop-content {
    height: auto;
  }
}
.my-esims-btn {
  transition: 0.3s ease-in-out !important;
  border-color: #F40C34 !important;
}

.my-esims-btn:hover {
  background-color: #F40C34 !important;
  color: white !important;
  border-color: #F40C34 !important;
}




/* Caja general */
.custom-select-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-bottom: 1px solid #cfcfcf;
  padding: 14px 12px;
  font-size: 15px;
  cursor: pointer;
}

/* Contenido izquierda */
.custom-select-label {
  display: flex;
  gap: 10px;
  align-items: center;
  color: #333;
  font-weight: 500;
  padding: 0px 12px 0px 0px 
}

/* Flecha roja */
.custom-select-arrow {
  color: #F40C34;
  font-size: 22px;
  font-weight: bold;
}

/* Oculta UI de mat-select y lo convierte en “invisible” */
.custom-mat-select .mat-select-trigger {
  display: none !important;
}
</style>
